import React, { useState } from "react";

const LanguageDropdown = ({ changeLanguage }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative inline-block text-left  ">
      {/* Buton */}
      <button
        onClick={() => setOpen(!open)}
        type="button"
        className="inline-flex justify-center w-full rounded-md border  shadow-sm px-4 py-2 m-3 ml-6 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
        id="menu-button"
        aria-expanded={open}
        aria-haspopup="true"
      >
        DİL
        <svg
          className="-mr-1 ml-2 h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.25a.75.75 0 01-1.06 0L5.23 8.27a.75.75 0 01.02-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      {/* Dropdown menü */}
      {open && (
        <div
          className="origin-top-right absolute right-0 mt-2 w-36 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="menu-button"
          tabIndex="-1"
        >
          <div className="py-1" role="none">
            <button
              onClick={() => {
                changeLanguage("tr");
                setOpen(false);
              }}
              className="text-gray-700 block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
              role="menuitem"
              tabIndex="-1"
              id="menu-item-0"
            >
              TURKISH
            </button>
            <button
              onClick={() => {
                changeLanguage("en");
                setOpen(false);
              }}
              className="text-gray-700 block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
              role="menuitem"
              tabIndex="-1"
              id="menu-item-1"
            >
              ENGLISH
            </button>
            <button
              onClick={() => {
                changeLanguage("ru");
                setOpen(false);
              }}
              className="text-gray-700 block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
              role="menuitem"
              tabIndex="-1"
              id="menu-item-1"
            >
              RUSSİAN
            </button>

            <button
              onClick={() => {
                changeLanguage("de");
                setOpen(false);
              }}
              className="text-gray-700 block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
              role="menuitem"
              tabIndex="-1"
              id="menu-item-1"
            >
              GERMAN
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageDropdown;
